import enUS from './en-US';
import zhCN from './zh-CN';
import { enUSStr, zhCNStr } from '@/constants';

const locales = {
    [enUSStr]: enUS,
    [zhCNStr]: zhCN,
};

export default locales;
